import "../../App.css";
import React, { useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, useNavigate } from "react-router-dom";
import {
  ConfigDataSidebarData,
  ConfigEmpSidebarData,
} from "../../Module/configDataSidebarData";
import AddIssueType from "./addIssueType";
import EditDeleteIssueType from "./editDeleteIssueType";
import Referral from "./AdditionalDiscount/referral";
import Influencer from "./AdditionalDiscount/influencer";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import { Logout, setInitialState } from "../../Action/authAction";
import SendPushNotification from "./sendPushNotification.js";
import GlobalSpecialDiscount from "./globalSpecialDiscount";

const AddBBBPDFandVideo = React.lazy(() => import("./addBBBPDFandVideo"));
const SupportNumber = React.lazy(() => import("./supportNumber"));
const SupportEmail = React.lazy(() => import("./supportEmail"));
const AdminEmail = React.lazy(() => import("./adminEmail"));
const Student = React.lazy(() => import("./AdditionalDiscount/student"));
const Pamplet = React.lazy(() => import("./AdditionalDiscount/pamplet"));
const InvoiceReceivedEmail = React.lazy(() => import("./invoiceReceivedEmail"));
const LiveVideoSetting = React.lazy(() => import("./liveVideoSetting"));
const TaxSetting = React.lazy(() => import("./taxSetting"));
const InstallmentSetting = React.lazy(() => import("./installmentSetting"));
const AddCharges = React.lazy(() => import("./addCharges"));
const EditDeleteCharges = React.lazy(() => import("./editDeleteCharges"));
const AppVersionControl = React.lazy(() => import("./appVersionControl"));
const OtpSetting = React.lazy(() => import("./otpSetting"));
const ServersList = React.lazy(() => import("./serversList"));
const AddQuestionConfig = React.lazy(() => import("./addQuestionConfig"));
const EditDeleteQuestionConfig = React.lazy(
  () => import("./editDeleteQuestionConfig"),
);
const AddQuestionIssue = React.lazy(
  () => import("./QuestionIssue/addQuestionIssue"),
);
const EditQuestionIssue = React.lazy(
  () => import("./QuestionIssue/editQuestionIssue"),
);
const WhatsappMsg = React.lazy(() => import("./whatsappMsg"));
const LeadOrdersSearch = React.lazy(() => import("./leadOrdersSearch"));
const WhatsappShootData = React.lazy(
  () => import("../CXOPanel/whatsappShootData"),
);
const MovementsOfMeeting = React.lazy(
  () => import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = React.lazy(
  () => import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const AddDataToReports = React.lazy(() => import("./addDataToReports"));
const WhatsappImage = React.lazy(() => import("./whatsappImage.js"));
const AddCampaign = React.lazy(() => import("./Campaign/addCampaign.js"));
const EditDeleteCampaign = React.lazy(
  () => import("./Campaign/editDeleteCampaign.js"),
);
const UserKycDetails = React.lazy(() => import("./userKyc/userKyc.js"));
const AddMailCampaign = React.lazy(
  () => import("./EmailCampaign/addMailCampaign.js"),
);
const EditDeleteEmailCamp = React.lazy(
  () => import("./EmailCampaign/editDeleteEmailCamp.js"),
);
const MailPushNotification = React.lazy(
  () => import("./EmailCampaign/mailPushNotification.js"),
);
const VerifyuserDetails = React.lazy(
  () => import("./VerifyuserDetails/VerifyuserDetails.js"),
);
const WhatsAppTemplateStatus = React.lazy(
  () => import("./WhatsAppTemplateStatus/whatsAppTemplateStatus.js"),
);
const CronManagement = React.lazy(
  () => import("../AdminPanel/CronManagement/CronManagement.js"),
);

function ConfigDataDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "CONFIG" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      <Sidebar
        data={loginType === 2 ? ConfigEmpSidebarData : ConfigDataSidebarData}
      />
      <div className="dashboard">
        <CommonRoutes loginType={loginType} defaultPage={<SupportNumber />}>
          <Route path="/" element={<SupportNumber />} />
          <Route path="supportNumber" element={<SupportNumber />} />
          <Route path="supportEmail" element={<SupportEmail />} />
          <Route path="adminEmail" element={<AdminEmail />} />
          <Route path="student" element={<Student />} />
          <Route path="pamplet" element={<Pamplet />} />
          <Route path="influencer" element={<Influencer />} />
          <Route path="referral" element={<Referral />} />
          <Route
            path="invoiceReceivedEmail"
            element={<InvoiceReceivedEmail />}
          />
          <Route path="liveVideoSetting" element={<LiveVideoSetting />} />
          <Route path="taxSetting" element={<TaxSetting />} />
          <Route path="installmentSetting" element={<InstallmentSetting />} />
          <Route path="addIssueType" element={<AddIssueType />} />
          <Route path="editDeleteIssueType" element={<EditDeleteIssueType />} />
          <Route path="addQuestionConfig" element={<AddQuestionConfig />} />
          <Route
            path="editDeleteQuestionConfig"
            element={<EditDeleteQuestionConfig />}
          />
          <Route path="addCharges" element={<AddCharges />} />
          <Route path="editDeleteCharges" element={<EditDeleteCharges />} />
          <Route path="appVersionControl" element={<AppVersionControl />} />
          <Route path="otpSetting" element={<OtpSetting />} />
          <Route path="serversList" element={<ServersList />} />
          <Route path="addQuestionIssue" element={<AddQuestionIssue />} />
          <Route path="editQuestionIssue" element={<EditQuestionIssue />} />
          <Route path="whatsappMsg" element={<WhatsappMsg />} />
          <Route path="leadOrdersSearch" element={<LeadOrdersSearch />} />
          <Route path="whatsappShotData" element={<WhatsappShootData />} />
          <Route path="addBBBPDFandVideo" element={<AddBBBPDFandVideo />} />
          <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
          <Route
            path="editMovementsOfMeeting"
            element={<EditMovementsOfMeeting />}
          />
          <Route path="addDataToReports" element={<AddDataToReports />} />
          <Route path="whatsappImg" element={<WhatsappImage />} />
          <Route path="addCampaign" element={<AddCampaign />} />
          <Route path="editDeleteCampaign" element={<EditDeleteCampaign />} />
          <Route
            path="sendPushNotification"
            element={<SendPushNotification />}
          />
          <Route
            path="globalSpecialDiscount"
            element={<GlobalSpecialDiscount />}
          />
          <Route path="userKycDetails" element={<UserKycDetails />} />
          <Route path="addMailCampaign" element={<AddMailCampaign />} />
          <Route path="editDeleteEmailCamp" element={<EditDeleteEmailCamp />} />
          <Route
            path="mailPushNotification"
            element={<MailPushNotification />}
          />
          <Route path="verifyuserDetails" element={<VerifyuserDetails />} />
          <Route
            path="whatsAppTemplateStatus"
            element={<WhatsAppTemplateStatus />}
          />
          <Route path="cronManagement" element={<CronManagement />} />
        </CommonRoutes>
      </div>
    </div>
  );
}

export default ConfigDataDashboard;
